import type { DayDoc, DayQuestion } from './types'
import bank from '@data/questions.json'

/** Premium practice: a random 10 from the bank (static-ish tiers only, so answers are never stale). */
export function practiceDay(): DayDoc {
  const pool = (bank as any[]).filter((q) => q.tier !== 'live' && q.tier !== 'yesterday' && !q.bonus)
  const picked: any[] = []
  const used = new Set<number>()
  while (picked.length < 5 && used.size < pool.length) {
    const i = Math.floor(Math.random() * pool.length)
    if (used.has(i)) continue
    used.add(i); picked.push(pool[i])
  }
  const questions: DayQuestion[] = picked.map((q) => ({
    id: q.id, prompt: q.prompt, answer: q.answer, unit: q.unit, tier: q.tier,
    hero: false, story: q.story, credit: q.credit, frozenAt: null,
  }))
  const heroIdx = Math.floor(Math.random() * questions.length)
  questions[heroIdx].hero = true
  questions.push(...questions.splice(heroIdx, 1))
  return {
    date: 'practice', number: 0, theme: { id: 'practice', name: 'Practice mix', emoji: '🎲' },
    questions, generatedAt: new Date().toISOString(), local: true,
  }
}
